module.exports = __webpack_public_path__ + "static/media/foto3.4c3e92b8.png";